import React from 'react';
import { Box, Container, Typography } from '@mui/material';

const TenantNotFound: React.FC = () => (
  <Container maxWidth="sm">
    <Box py={8} textAlign="center">
      <Typography variant="h5" fontWeight={700} gutterBottom>
        Tienda no encontrada
      </Typography>
      <Typography color="text.secondary">
        No pudimos identificar la empresa para el dominio{' '}
        <strong>{window.location.hostname}</strong>.
      </Typography>
      <Typography color="text.secondary" sx={{ mt: 2 }}>
        En desarrollo local, configurá <code>tenantCode</code> en{' '}
        <code>public/config.json</code>.
      </Typography>
    </Box>
  </Container>
);

export default TenantNotFound;
